import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-df83cb9c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("新增行")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("删除选中")
const _hoisted_3 = ["src"]
const _hoisted_4 = { key: 1 }
const _hoisted_5 = ["src"]
const _hoisted_6 = { key: 1 }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["onClick"]

export function render(_ctx, _cache) {
  const _component_a_button = _resolveComponent("a-button")
  const _component_a_space = _resolveComponent("a-space")
  const _component_workPackage_select = _resolveComponent("workPackage-select")
  const _component_table_wrapper = _resolveComponent("table-wrapper")
  const _component_a_card = _resolveComponent("a-card")

  return (_openBlock(), _createBlock(_component_a_card, { class: "mb50" }, {
    default: _withCtx(() => [
      _createVNode(_component_table_wrapper, {
        "row-key": 'uuid',
        ref: "tableWrappers",
        dataSource: _ctx.records,
        showCheckbox: true,
        columns: _ctx.columns,
        onOnSelectionChange: _ctx.onSelectionChange
      }, {
        buttons: _withCtx(() => [
          _createVNode(_component_a_space, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_button, {
                type: "primary",
                onClick: _ctx.addRow
              }, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_a_button, {
                disabled: _ctx.selectedUuids.length === 0,
                onClick: _ctx.deleteRows
              }, {
                default: _withCtx(() => [
                  _hoisted_2
                ]),
                _: 1
              }, 8, ["disabled", "onClick"])
            ]),
            _: 1
          })
        ]),
        workPackagesId: _withCtx(({ record }) => [
          _createVNode(_component_workPackage_select, {
            value: record.workPackagesId,
            "onUpdate:value": $event => ((record.workPackagesId) = $event),
            class: "w100 append-to-table",
            placeholder: "请选择工作包",
            allowClear: false,
            onChange: $event => (_ctx.workPackageChange($event,record))
          }, null, 8, ["value", "onUpdate:value", "onChange"])
        ]),
        isPhotograph: _withCtx(({ record } ) => [
          (record.isPhotograph==1)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                class: "tb-img",
                src: _ctx.isZHXH?_ctx.checkRightGreen:_ctx.checkRight,
                alt: ""
              }, null, 8, _hoisted_3))
            : (_openBlock(), _createElementBlock("span", _hoisted_4, "-"))
        ]),
        isExplain: _withCtx(({ record } ) => [
          (record.isExplain==1)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                class: "tb-img",
                src: _ctx.isZHXH?_ctx.checkRightGreen:_ctx.checkRight,
                alt: ""
              }, null, 8, _hoisted_5))
            : (_openBlock(), _createElementBlock("span", _hoisted_6, "-"))
        ]),
        operation: _withCtx(({ record }) => [
          _createVNode(_component_a_space, { size: 16 }, {
            default: _withCtx(() => [
              (record.sortValue!=1)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: "javascript:void(0)",
                    onClick: $event => (_ctx.moveTask(record,'p'))
                  }, "上移", 8, _hoisted_7))
                : _createCommentVNode("", true),
              (record.sortValue!=(_ctx.records.length))
                ? (_openBlock(), _createElementBlock("a", {
                    key: 1,
                    href: "javascript:void(0)",
                    onClick: $event => (_ctx.moveTask(record,'n'))
                  }, "下移", 8, _hoisted_8))
                : _createCommentVNode("", true),
              (record.sortValue!=1)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 2,
                    href: "javascript:void(0)",
                    onClick: $event => (_ctx.moveTask(record,'t'))
                  }, "置顶", 8, _hoisted_9))
                : _createCommentVNode("", true),
              (record.sortValue!=(_ctx.records.length))
                ? (_openBlock(), _createElementBlock("a", {
                    key: 3,
                    href: "javascript:void(0)",
                    onClick: $event => (_ctx.moveTask(record,'b'))
                  }, "置底", 8, _hoisted_10))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1024)
        ]),
        _: 1
      }, 8, ["dataSource", "columns", "onOnSelectionChange"])
    ]),
    _: 1
  }))
}